import { useContext } from 'react';
import { GallectionType } from '../../types/gallection';
import { isSpecialStuckGallection } from '../../MediaPopup/helpers';
import { MobileContext } from '@wix/da-react-context/pkg/MobileContext';
import { isGroup } from '../../User/helpers';
import { normalizePremiumFolderData } from '../normalizePremiumFolderData';
import { useFlag } from '@wix/da-react-context/pkg/flags/hooks';
import { useCurrentUser } from './useCurrentUser';
export default function useIsSellableAsPremiumGallery(currentFolder) {
    const gallery_thumb_premium_flow = useFlag('gallery_thumb_premium_flow');
    const isMobile = useContext(MobileContext);
    const currentUser = useCurrentUser();
    if (!currentFolder) {
        return false;
    }
    const isOwner = (currentFolder === null || currentFolder === void 0 ? void 0 : currentFolder.owner.userId) === currentUser.userId;
    const isGallery = (currentFolder === null || currentFolder === void 0 ? void 0 : currentFolder.type) === GallectionType.GALLERY;
    const { isPaidFolder, isWatchToAccess } = normalizePremiumFolderData(currentFolder === null || currentFolder === void 0 ? void 0 : currentFolder.premiumFolderData);
    return gallery_thumb_premium_flow && isOwner && isGallery && !isGroup(currentFolder === null || currentFolder === void 0 ? void 0 : currentFolder.owner) && !isMobile && !isWatchToAccess && !isPaidFolder && !currentFolder.hasSubfolders && !isSpecialStuckGallection(currentFolder);
}
